import React, { createContext, FC, ReactNode, useState } from 'react';

export interface HeaderContextProps {
  headerRightItems: ReactNode;
  setHeaderRightItems: (items: ReactNode) => void;
  subHeaderLeftItems: ReactNode;
  setSubHeaderLeftItems: (items: ReactNode) => void;
  subHeaderRightItems: ReactNode;
  setSubHeaderRightItems: (items: ReactNode) => void;
  subHeaderSearchItems: ReactNode;
  setSubHeaderSearchItems: (items: ReactNode) => void;
  disableAnimation: boolean;
  setDisableAnimation: (disable: boolean) => void;
}

interface HeaderProviderProps {
  children: ReactNode;
}

const HeaderContext = createContext<HeaderContextProps>({
  headerRightItems: undefined,
  setHeaderRightItems: undefined,
  subHeaderLeftItems: undefined,
  setSubHeaderLeftItems: undefined,
  subHeaderRightItems: undefined,
  setSubHeaderRightItems: undefined,
  subHeaderSearchItems: undefined,
  setSubHeaderSearchItems: undefined,
  disableAnimation: true,
  setDisableAnimation: undefined,
});

export const HeaderProvider: FC<HeaderProviderProps> = ({ children }) => {
  const [headerRightItems, setHeaderRightItems] = useState<ReactNode>(undefined);
  const [subHeaderLeftItems, setSubHeaderLeftItems] = useState<ReactNode>(undefined);
  const [subHeaderRightItems, setSubHeaderRightItems] = useState<ReactNode>(undefined);
  const [subHeaderSearchItems, setSubHeaderSearchItems] = useState<ReactNode>(undefined);
  const [disableAnimation, setDisableAnimation] = useState<boolean>(true);

  return (
    <HeaderContext.Provider
      value={{
        headerRightItems,
        setHeaderRightItems,
        subHeaderLeftItems,
        setSubHeaderLeftItems,
        subHeaderRightItems,
        setSubHeaderRightItems,
        subHeaderSearchItems,
        setSubHeaderSearchItems,
        disableAnimation,
        setDisableAnimation,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext: () => HeaderContextProps = () => {
  return React.useContext(HeaderContext);
};
